import { render, staticRenderFns } from "./telcoOtp.vue?vue&type=template&id=18a84890&"
import script from "./telcoOtp.vue?vue&type=script&lang=js&"
export * from "./telcoOtp.vue?vue&type=script&lang=js&"
import style0 from "./telcoOtp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports